/*
 * @Author: your name
 * @Date: 2021-07-29 18:21:22
 * @LastEditTime: 2023-10-18 19:26:16
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\api\cms-oss\index.js
 */
import axios from 'axios';
// import axios from 'more-request/instance';

// let baseOssUrl='https://wuzhuang-uat02.oss-cn-beijing.aliyuncs.com/'
import { baseOssUrl } from '../config';

const api = {
  // 获取店铺oss数据
  getShopTemplateossUrl: (params) => {
    return axios.get(
      `${baseOssUrl}` +
      `cmsFile/template/${params.companyId}/${params.columeId}${params.shopId}.json`,
      { params: { v: new Date().getTime() } }
    );
  },
  getAllCategory: () => {
    return axios.get(`${baseOssUrl}` + 'productFile/Category/category.json', {
      params: { v: new Date().getTime() },
    });
  },
  purchaseAreaCategory: (params) => {
    return axios.get(
      `${baseOssUrl}productFile/purchaseAreaCategory/${params.companyId}.json`,
      { params: { v: new Date().getTime() } }
    );
  },
  purchaseAreaRecommendCategory: () => {
    return axios.get(
      `${baseOssUrl}` +
      'productFile/purchaseAreaRecommendCategory/recommendCategory.json',
      { params: { v: new Date().getTime() } }
    );
  },
};
export default api;
